/**
 * This service serve parameters for ruler.
 */
class RulerService {
    calcMatchScores(questions) {
        let sumPin = 0;
        let sumGlass = 0;
        let deviation = 0;
        let paramName = '';
        let answeredQuestionsNumber = 0;
        Object.keys(questions).forEach((index) => {
            if (Number.isInteger(questions[index].magnifyingGlass)) {

                let glass = questions[index].magnifyingGlass;
                let pin = Number.isInteger(questions[index].pin) ? questions[index].pin : questions[index].magnifyingGlass;

                sumPin += pin;
                sumGlass += glass;
                deviation += Math.abs(glass - pin);
                ++answeredQuestionsNumber;
            }
            paramName = questions[index].parameter;
        });
        const divider = 4 * answeredQuestionsNumber;
        const matchScore = 1 - (deviation / divider);

        return {
            paramName: paramName.split(' - '),
            sumPin: isNaN(sumPin) ? '-' : sumPin,
            sumGlass: isNaN(sumGlass) ? '-' : sumGlass,
            accurateMatchScore: matchScore,
            matchScore: isNaN(matchScore) ? '-' : Math.round(matchScore * 100),
            maxValue: divider / 2,
        };
    }
}

export default RulerService;



// WEBPACK FOOTER //
// ./src/app/pages/evaluation/pages/stepPedagogicalApproach/services/rulerService.js